<template>
    <div class="dropdown" @mouseover="onContainerMouseOver"
         @mouseout="onContainerMouseOut"
         :style="getDropdownStyle"
         :class="{ 'disabled': disabled }"
         @focusout="onFocusOut"
         :tabindex="0">
        <icon :name="caret" class="arrow" v-if="showArrow" />

        <div class="item" :style="styling.item">
            <template v-if="!autoComplete">
                {{ getSelectedItemName }}
            </template>
            <template v-else>
                <input type="text"
                       class="autocomplete-text"
                       v-model.trim="autoCompleteText"
                       :placeholder="displayName" />
            </template>
        </div>

        <div class="drop-down-menu" v-show="isMenuVisible" :style="getDropdownMenuStyle">
            <div class="sub-item"
                 :class="{ 'disabled': item.disabled }"
                 v-for="item in dropDownItems"
                 @click="selectItem(item)"
                 :style="styling.subItem"
                 v-show="(typeof item.isVisible == 'undefined' || item.isVisible === true)">
                <span class="item-text"
                      v-html="highlight({value: item.name, text: autoCompleteText, style: 'font-weight: bold; color: black;'})"></span>
            </div>
        </div>
    </div>
</template>

<script>

    import zIndexMixins from '../../mixins/zIndexMixins';
    import highlightMixins from '../../mixins/highlightTextMixins';

    export default {

        mixins: [zIndexMixins, highlightMixins],

        props: {
            autoComplete: {
                type: Boolean,
                default: false
            },
            items: {
                type: Array,
                required: true
            },
            value: {
                type: Object
            },
            height: {
                type: Number
            },
            width: {
                type: Number,
                default: 170
            },
            displayName: {
                type: String,
                default: 'Select'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            selectedIndex: {
                type: Number
            },
            showArrow: {
                type: Boolean,
                default: true
            },
            styling: {
                default: () => {
                    return {
                        dropdownMenu: {},
                        dropdown: {},
                        item: {},
                        subItem: {}
                    }
                }
            }
        },

        data() {

            return {
                showMenu: false,
                selectedItem: null,
                caret: 'caret-down',
                autoCompleteText: '',
                isCreatedEvent : true
            };

        },

        created() {
            this.setValueBySelectedIndex();
        },

        watch: {

            selectedIndex(value) {
                this.setValueBySelectedIndex();
            },

            showMenu(value) {
                if (value)
                    this.caret = 'caret-up';
                else
                    this.caret = 'caret-down';
            }

        },

        computed: {

            isMenuVisible() {
                if (!this.autoComplete)
                    return this.showMenu && this.dropDownItems.length > 0;

                return this.dropDownItems.length > 0 && this.showMenu;
            },

            getDropdownStyle() {

                let css = {
                    zIndex: this.getZIndex
                }

                if (this.width)
                    css.width = this.width + 'px';

                Object.assign(css, this.styling.dropdown);

                return css;

            },

            getDropdownMenuStyle() {

                let css = {};

                if (this.height) {
                    css.maxHeight = this.height + 'px';
                    css.overflow = 'auto';
                }
                else
                    css['overflow-y'] = 'hidden';

                Object.assign(css, this.styling.dropdownMenu)

                return css;
            },

            dropDownItems() {

                if (!this.autoComplete) {
                    return this.items.filter((item) => {
                        return item != this.selectedItem;
                    });
                }

                // autocomplete mode
                if (this.autoCompleteText.length == 0)
                    return this.items;

                return this.items.filter((item) => {
                    return item.name.toLowerCase().includes(this.autoCompleteText.toLowerCase());
                });

            },

            getSelectedItemName() {

                if (this.value)
                    return this.value.name;

                if (this.displayName)
                    return this.displayName;

            }

        },

        updated() {
            this.isCreatedEvent = false;
        },

        methods: {

            onFocusOut() {
                if (this.autoComplete) {
                    var item = this.items.find((c) => {
                        return c.name == this.autoCompleteText;
                    });
                    if (!item) {
                        this.selectedItem = null;
                        this.$emit('input', null);
                    }
                }
            },

            setValueBySelectedIndex() {
                if (typeof this.selectedIndex != 'undefined') {
                    let item = this.items[this.selectedIndex];
                    this.$emit('input', item);
                    this.selectedItem = item;
                }
            },

            selectItem(item) {
                this.showMenu = false;
                this.$emit('input', item);
                this.selectedItem = item;

                if (this.autoComplete)
                    this.autoCompleteText = this.selectedItem.name;
            },

            onContainerMouseOver(e) {
                if (!this.showMenu) {
                    this.setZIndex();
                    this.showMenu = true;
                    this.$emit('open');
                }
            },

            onContainerMouseOut() {
                if (this.showMenu) {
                    this.showMenu = false;
                    this.$emit('close');
                }
            }

        }

    }

</script>

<style lang="scss" scoped>

    @import '../../style/thin-scrollbar.scss';

    .dropdown:hover {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .dropdown.disabled {
        pointer-events: none;
    }

        .dropdown.disabled .item {
            color: #C0C0C0 !important;
        }

        .dropdown.disabled .arrow {
            color: #C0C0C0;
        }

    .dropdown {
        width: 170px;
        height: 30px;
        background: white;
        border: 1px solid #ddd;
        -webkit-border-radius: 5px;
        line-height: 30px;
        outline: 0;
        .autocomplete-text

    {
        width: 75%;
        border: 0;
        outline: 0;
        font: inherit;
        color: inherit;
        height: 70%;
    }

    .arrow {
        float: right;
        margin-right: 7px;
        margin-top: 6px;
    }

    .drop-down-menu {
        position: absolute;
        background: white;
        width: inherit;
        overflow-y: scroll;
        overflow-x: hidden;
        border: 1px solid #ddd;
        margin-left: -1px;
    }

    .sub-item {
        color: #8c8c8c;
        width: inherit;
        height: 30px;
        color: #8C8C8C;
        font-family: Arial;
        font-size: 12px;
        font-weight: bold;
        border-bottom: 1px solid #ddd;
    }

        .sub-item.disabled {
            pointer-events: none;
            opacity: 0.5;
        }

        .sub-item:last-child {
            border-bottom: 0px;
        }

    .item-text {
        margin-left: 12px;
    }

    .sub-item:hover {
        background: #F2F2F2;
        cursor: pointer;
    }

    .item {
        width: 100%;
        height: 100%;
        color: #6f6f6f;
        font-family: Arial;
        font-size: 14px;
        font-weight: bold;
        padding-left: 10px;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/Dropdown.vue